export const BACKOFFICE_ROLES = ['realtor', 'manager', 'supervisor'] as const;
export const USER_ROLES = ['anonymous', 'identified_person'] as const;
export const APP_ROLES = ['viestimedia'] as const;
export const ROLES = [
  ...BACKOFFICE_ROLES,
  ...USER_ROLES,
  ...APP_ROLES,
] as const;
